import { render } from "./CampoCpfCnpj.vue?vue&type=template&id=fbe48332&ts=true"
import script from "./CampoCpfCnpj.vue?vue&type=script&lang=ts"
export * from "./CampoCpfCnpj.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__